// extracted by mini-css-extract-plugin
export default {"control":"LanguagePicker_control__goKKV","label":"LanguagePicker_label__Ek4X3","icon":"LanguagePicker_icon__7KdZ0"};